/**
 * NGUỒN DỮ LIỆU DÙNG CHUNG — Công cụ miễn phí / ít tốn credit, phổ biến.
 * Mục đích: nổi bật các tính năng "mồi" thu hút người dùng, dùng lại ở nhiều nơi:
 *   - Header menu (nhóm "Miễn phí")
 *   - Trang landing theo nhóm (khối "Công cụ miễn phí nổi bật")
 *   - (Có thể) trang chủ / hub
 *
 * Route 🔒 (requiresLogin) khi bấm sẽ tự chạy deep-link login (giữ ?returnUrl) — xem utils/returnUrl.
 */

export type FreeToolBadge = 'free' | 'low';

/** Đối tượng chính công cụ nhắm tới — dùng để nhóm hiển thị đúng ngữ cảnh (header, landing). */
export type FreeToolAudience = 'teacher' | 'student' | 'parent' | 'all';

export interface FreeTool {
  key: string;
  label: string;
  description: string;
  /** Route nội bộ (react-router). */
  path: string;
  /** true nếu cần đăng nhập (vẫn không/ít tốn credit). */
  requiresLogin: boolean;
  /** tabler icon name (không kèm `ti ti-`). */
  icon: string;
  badge: FreeToolBadge;
  /** Đối tượng chính (giáo viên / học sinh / phụ huynh / dùng chung). */
  audience: FreeToolAudience;
  /** Nhấn mạnh (2 mục người dùng ưu tiên). */
  spotlight?: boolean;
}

export const FREE_TOOL_BADGE_LABEL: Record<FreeToolBadge, string> = {
  free: 'Miễn phí',
  low: 'Ít credit',
};

export const FREE_TOOL_AUDIENCE_LABEL: Record<FreeToolAudience, string> = {
  teacher: 'Giáo viên',
  student: 'Học sinh',
  parent: 'Phụ huynh',
  all: 'Dùng chung',
};

/** Thứ tự hiển thị nhóm đối tượng trong menu "Miễn phí" & khối landing. */
export const FREE_TOOL_AUDIENCE_ORDER: FreeToolAudience[] = ['teacher', 'student', 'parent', 'all'];

export const FREE_TOOLS: FreeTool[] = [
  {
    key: 'classroom-toolbox',
    label: 'Hộp công cụ lớp học',
    description: 'Vòng quay chọn tên, đồng hồ đếm ngược, chia nhóm, đo tiếng ồn… Dùng ngay, không cần đăng nhập.',
    path: '/hop-cong-cu-lop',
    requiresLogin: false,
    icon: 'dice-5',
    badge: 'free',
    audience: 'teacher',
    spotlight: true,
  },
  {
    key: 'pet-classroom',
    label: 'Lớp học Thú cưng',
    description: 'Thú cưng đồng hành tạo động lực và nề nếp cho lớp — gamification không tốn credit.',
    path: '/workspace/giao-vien/thu-cung',
    requiresLogin: true,
    icon: 'mood-smile',
    badge: 'free',
    audience: 'teacher',
    spotlight: true,
  },
  {
    key: 'live-quiz',
    label: 'Live Quiz',
    description: 'Trả lời quiz realtime bằng mã PIN kiểu Kahoot — miễn phí cho học sinh tham gia.',
    path: '/choi',
    requiresLogin: false,
    icon: 'bolt',
    badge: 'free',
    audience: 'student',
  },
  {
    key: 'community-library',
    label: 'Thư viện cộng đồng',
    description: 'Duyệt và sao chép hàng nghìn học liệu chia sẻ (giáo án, đề, trò chơi…) — miễn phí.',
    path: '/thu-vien-cong-dong',
    requiresLogin: false,
    icon: 'books',
    badge: 'free',
    audience: 'all',
  },
  {
    key: 'mindmap',
    label: 'Sơ đồ tư duy',
    description: 'Hệ thống hoá kiến thức thành mindmap + flashcard, ôn tập lặp lại ngắt quãng.',
    path: '/so-do-tu-duy',
    requiresLogin: true,
    icon: 'sitemap',
    badge: 'low',
    audience: 'all',
  },
];
